/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    title: 'My Order is late or missing',
    orderDateDescription: 'If you have a late or missing order, we can help. If the delivery window has passed and your recipient has checked where contactless packages are typically dropped off, follow these steps and we’ll get you back on track.',
    steps: [
        {
            title: 'If you have a late or missing order, here are some things you can check on first.',
            deliveryInfo: [],
        },
        {
            title: 'You can find your',
            link: 'gift&apos;s current status here.',
            href: '/account/orders',
            deliveryInfo: [
                {
                    title: 'Deliveries are typically made until 8PM in your recipient\'s timezone.',
                },
                {
                    title: 'You will receive a confirmation email when your gift has been delivered.',
                },
                {
                    title: 'If your order was delivered but your recipient doesn’t see it, please ask them to check the following locations: front porch, front desk, package room, building lobby, or wherever contactless packages can be safely delivered.',
                },
            ],
        },
        {
            title: 'If you still have questions about your order,',
            link: 'chat with us.',
            deliveryInfo: [],
        },
    ],
    orderOptions: [
        {
            title: '',
            option: [
                {
                    title: 'What to expect when flowers arrive',
                    link: '/customer-service-help-videos',
                },
            ],
        },
    ],
    seo: {
        page_title: 'Customer Service My Order',
    },
};
export default data;
